module.exports = {
  'OIDCWebClient': require('./OIDCWebClient'),
  'LocalJsonStore': require('./LocalJsonStore')
}



// WEBPACK FOOTER //
// ./src/index.js